import { cn } from "@/lib/utils";

const FormSectionHeader = ({
  children,
  className,
  wrapperClassName,
}: {
  children: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
}) => {
  return (
    <div className={cn("flex items-start mb-6", wrapperClassName)}>
      <h4 className={cn("font-[500] text-[16px] text-start", className)}>
        {children}
      </h4>
    </div>
  );
};

export default FormSectionHeader;
